import { IVideoLessionFile, IVideoLessionProgramFilter } from "../../schoolPrograms/videoLessionProgram/VideoLessionFileModels";
import { Subjects, SubjectsData } from "./subjects";

export const VideoLessionPrograms = [
    {
        filterId:1,
        filterName:'1st - 5th Class',
        subjects:[
            {
                subjectId:Subjects.Maths.subjectId,
                subjectName:Subjects.Maths.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Science.subjectId,
                subjectName:Subjects.Science.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Reasoning.subjectId,
                subjectName:Subjects.Reasoning.subjectName,
                videoLessionFiles:[]
            }
                
        ]

    } as IVideoLessionProgramFilter,
    {
        filterId:2,
        filterName:'6th - 10th Class',
        subjects:[
            {
                subjectId:Subjects.Maths.subjectId,
                subjectName:Subjects.Maths.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Physics.subjectId,
                subjectName:Subjects.Physics.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Chemistry.subjectId,
                subjectName:Subjects.Chemistry.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Reasoning.subjectId,
                subjectName:Subjects.Reasoning.subjectName,
                videoLessionFiles:[]
            },
            {
                subjectId:Subjects.Biology.subjectId,
                subjectName:Subjects.Biology.subjectName,
                videoLessionFiles:[]
            }
            
        ]
    }
];